export default __webpack_public_path__ + "static/media/gloves_of_the_forsaken.c78b67e3.jpg";